<app-modal
  height="100%"
  width="100%"
  [compact]="true"
  class="ots-staff-modal"
>
  <ng-template>
    <ots-staff-dashboard-page class="full-width d-flex full-height" />
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        type="button"
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Close' | trans:'cx-entry/cx-entry-modal/close.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
